import React, { Component } from 'react'
import { addLocaleData, IntlProvider } from 'react-intl'
import PropTypes from 'prop-types'
import axios from 'axios'
import moment from 'moment'

import enLocaleData from 'react-intl/locale-data/en'
import daLocaleData from 'react-intl/locale-data/da'
import deLocaleData from 'react-intl/locale-data/de'
import esLocaleData from 'react-intl/locale-data/es'
import frLocaleData from 'react-intl/locale-data/fr'
import itLocaleData from 'react-intl/locale-data/it'
import nlLocaleData from 'react-intl/locale-data/nl'
import noLocaleData from 'react-intl/locale-data/no'
import plLocaleData from 'react-intl/locale-data/pl'
import ptLocaleData from 'react-intl/locale-data/pt'
import ruLocaleData from 'react-intl/locale-data/ru'
import svLocaleData from 'react-intl/locale-data/sv'
import jaLocaleData from 'react-intl/locale-data/ja'
import koLocaleData from 'react-intl/locale-data/ko'
import thLocaleData from 'react-intl/locale-data/th'
import zhLocaleData from 'react-intl/locale-data/zh'
import roLocaleData from 'react-intl/locale-data/ro'
import msLocaleData from 'react-intl/locale-data/ms'
import csLocaleData from 'react-intl/locale-data/cs'
import huLocaleData from 'react-intl/locale-data/hu'
import elLocaleData from 'react-intl/locale-data/el'
import fiLocaleData from 'react-intl/locale-data/fi'
import skLocaleData from 'react-intl/locale-data/sk'
import hrLocaleData from 'react-intl/locale-data/hr'
import IntlGlobalProvider from 'common/components/l10n/IntlGlobalProvider'
import { DEFAULT_LANGUAGE, DEFAULT_LOCALE } from 'common/utils/constants'
import { setMomentLocale } from 'common/utils/moment'
import { getLocaleFromLanguageCode } from 'common/utils/localeUtils'

const getManifestPath = () => MANIFEST_PATH
const getl10nPath = () => L10N_PATH

addLocaleData([
  ...enLocaleData,
  ...daLocaleData,
  ...deLocaleData,
  ...esLocaleData,
  ...frLocaleData,
  ...itLocaleData,
  ...nlLocaleData,
  ...noLocaleData,
  ...plLocaleData,
  ...ptLocaleData,
  ...ruLocaleData,
  ...svLocaleData,
  ...jaLocaleData,
  ...koLocaleData,
  ...thLocaleData,
  ...zhLocaleData,
  ...roLocaleData,
  ...msLocaleData,
  ...csLocaleData,
  ...huLocaleData,
  ...elLocaleData,
  ...fiLocaleData,
  ...skLocaleData,
  ...hrLocaleData,
])

class L10nWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      languageCode: DEFAULT_LOCALE,
      [props.languageCode]: null,
      languageLoadError: false,
    }
  }

  componentWillMount() {
    this.loadTranslations()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.languageCode !== this.props.languageCode) {
      this.loadTranslations()
    }
  }

  loadTranslationStrings = () => {
    // time stamp is to stop client from caching manifest file
    const url = `${getManifestPath()}?timestamp=${moment().format('YYYYMMDDHHMM')}`
    axios.get(url)

    // Get translation url from the manifest
    .then((response) => (
      new Promise((resolve) => {
        const manifest = response.data
        resolve(manifest[`translations-${this.props.languageCode}.json`])
      })
    ))

    // Get translations file
    .then((languageFile) => (
      new Promise((resolve, reject) => {
        if (languageFile) {
          axios.get(`${getl10nPath()}${languageFile}`)
          .then((response) => {
            resolve(response.data)
          })
        } else {
          reject()
        }
      })
    ))

    // Load translation into state
    .then((langaugeData) => {
      this.setState({
        [this.props.languageCode]: langaugeData,
        languageCode: this.props.languageCode,
      })
      this.setHtmlLang()
    })

    // On Error will just go into error state
    .catch((error) => {
      /* eslint-disable no-console */
      console.log('error', error)
      /* eslint-enable no-console */
      this.setState({
        languageLoadError: true,
      })
    })
  }

  loadTranslations = () => {
    if (this.props.languageCode != DEFAULT_LANGUAGE) {
      this.loadTranslationStrings()
    } else {
      this.setState({
        languageCode: this.props.languageCode,
      })
      this.setHtmlLang()
    }
    setMomentLocale(this.props.languageCode)
  }

  setHtmlLang = () => {
    document.documentElement.lang = this.props.languageCode
  }

  render() {
    const locale = getLocaleFromLanguageCode(this.state.languageCode)

    return (
      <IntlProvider
        defaultLocale={DEFAULT_LOCALE}
        locale={locale}
        key={locale}
        messages={this.state[this.state.languageCode]}
      >
        <IntlGlobalProvider>
          {this.props.children}
        </IntlGlobalProvider>
      </IntlProvider>
    )
  }
}

L10nWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  languageCode: PropTypes.string.isRequired,
}

export default L10nWrapper
